import React from "react";

const PreviousArrow: React.FC = () => {
    return (
        <svg
            width="14"
            height="25"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path d="M12.9072 23.815L1.49973 12.4075L12.9072 1" stroke="#323132" stroke-width="2" />
        </svg>
    );
};

export default React.memo(PreviousArrow);
